import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Desarrollado por Deiby Od. © Copyright 2025. v.1.4.1</p>
    </footer>
  );
};

export default Footer;